import _defineProperty from "/workdir/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { ConfigError } from '../util/Errors.js';
import Util from '../util/Util.js';
import config from '../config/config.json.js';

function getAuthClientInstance(OktaAuth) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // if authClient is set, authParams are disregarded
  var authClient = options.authClient,
      authParams = options.authParams;

  if (!authClient) {
    // Create an authClient using widget options and optional authParams
    var issuer = options.issuer,
        clientId = options.clientId,
        redirectUri = options.redirectUri,
        state = options.state,
        scopes = options.scopes,
        flow = options.flow,
        codeChallenge = options.codeChallenge,
        codeChallengeMethod = options.codeChallengeMethod,
        recoveryToken = options.recoveryToken;
    authParams = _objectSpread({
      issuer: issuer,
      clientId: clientId,
      redirectUri: redirectUri,
      state: state,
      scopes: scopes,
      flow: flow,
      codeChallenge: codeChallenge,
      codeChallengeMethod: codeChallengeMethod,
      transformErrorXHR: Util.transformErrorXHR,
      recoveryToken: recoveryToken
    }, authParams);

    if (!authParams.issuer) {
      authParams.issuer = options.baseUrl + '/oauth2/default';
    }

    authClient = new OktaAuth(authParams);
  } // Add widget version to extended user agent header


  if (!authClient._oktaUserAgent) {
    throw new ConfigError('The passed in authClient should be version 5.4.0 or above.');
  } else {
    authClient._oktaUserAgent.addEnvironment("okta-signin-widget-".concat(config.version));
  }

  return authClient;
}

export { getAuthClientInstance as default };